function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.2346 3.23478C22.1052 2.75376 21.8515 2.31528 21.4989 1.96336C21.1464 1.61144 20.7075 1.35849 20.2262 1.2299C18.452 0.750854 11.3551 0.750854 11.3551 0.750854C11.3551 0.750854 4.25815 0.750854 2.48392 1.2299C2.00268 1.35849 1.56375 1.61144 1.21121 1.96336C0.858666 2.31528 0.604934 2.75376 0.475493 3.23478C0 5.0303 0 8.75263 0 8.75263C0 8.75263 0 12.4608 0.475493 14.2527C0.602753 14.7364 0.855515 15.1778 1.2082 15.5324C1.56088 15.8869 2.00097 16.142 2.48392 16.2718C4.25815 16.7509 11.3551 16.7509 11.3551 16.7509C11.3551 16.7509 18.452 16.7509 20.2262 16.2718C20.7092 16.142 21.1493 15.8869 21.5019 15.5324C21.8546 15.1778 22.1074 14.7364 22.2346 14.2527C22.7101 12.4608 22.7101 8.75263 22.7101 8.75263C22.7101 8.75263 22.7101 5.0303 22.2346 3.23478ZM9.03083 12.1059V5.36385L14.9674 8.74198L9.03083 12.1059Z",
  fill: "white"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.fc182cb1.svg";
export { ForwardRef as ReactComponent };